import React, {PureComponent as Component} from 'react';
import { withRouter } from "react-router"; 
import Loading from "../../../../ui/template/Loading/Loading"; 
import {MCbrowser} from "../../../Context/browserContext";
import MosavabatInsert from "../Controllers/MosavabatInsert";
import ShowProfile from "../../../Controllers/Dashboard/ShowProfile";
import ShowInvertFriend from "../../Friend/Controllers/ShowInvertFriend";
import queryString from 'query-string';

class   InsertMosavabatLayout  extends Component{

    constructor(props) {
        super(props);
        this.isAlive = true;


        this.state = {loaded: true};

        this.props=props;
    }
 

    componentDidMount(){

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!prevState.loaded) {
            if (this.context.page.pageBreadcrumbs.current != null) {
                this.context.page.pageBreadcrumbs.current.setCurrent("insertMosavabat");
                this.context.page.pageBreadcrumbs.current.show();
            }
        }
    }

    render() {
        const parsed =    queryString.parse(this.props.location.search);

        if (this.state.loaded) {
            let c1=null;
            if(Object.prototype.hasOwnProperty.call(parsed,'cat1') ) c1=parsed.cat1;
            let c2=null;
            if(Object.prototype.hasOwnProperty.call(parsed,'cat2') )  c2=parsed.cat2;

            return (
                <React.Fragment>
                    <div className="row">
                        <aside  className="col col-xl-3 order-xl-1 col-lg-6 order-lg-2 col-md-6 col-sm-12 col-12 side-sticky">
                           <ShowProfile  />
                           <ShowInvertFriend />
                        </aside>
                        <main className="col col-xl-9 order-xl-2 col-lg-6 order-lg-1 col-md-6 col-sm-12 col-12">
                            <MosavabatInsert cat1={c1}   cat2={c2}   />
                        </main>
                    </div>
                </React.Fragment>
            );
        }else{
            return <Loading type="Chase" /> ;
        }
    }

    destroy() {
        if (!this.isAlive) {
            return;
        }

        this.isAlive = false;
    }

    componentWillUnmount() {
        this.destroy();
    }
}

InsertMosavabatLayout.contextType = MCbrowser;

export default withRouter(InsertMosavabatLayout);
